import { IResultDisplay, Section, Item } from './returnDisplay';
import { TransformBoolean, DefaultValue } from './utilities';
import { IFraudForceResult } from './fraudForce';
import IdentityVerification from './identityVerification';
import { trans } from '@/i18n';
// import $ from 'axios';

export const CaseType = [
    'Default',
    'AccountLogin',
    'AccountCreation',
    'Application',
    'ADR',
];

export const ResultHelper = [
    'Unknown',
    'Pass',
    'Flag',
    'Fail',
];

export const StatusHelper = [
    'Completed',
    'RejectedFraud',
    'RejectedAuthFailure',
    'RejectedSuspicious',
    'Cancelled',
    'ChargebackFraud',
    'ChargebackOther',
    'Refunded',
    'Placed',
    'OnHoldReview',
    'ReportedFraud',
    'AccountTakeover',
    'AccountTakeoverChargeback',
];

export interface GeneralAuthentication {
    color: string;
    phone: string;
    url: string;
    title: string;
    description: string;
    AnswerUrl?: string;
    MultiPassQuestions?: IMultiPassQuestionsItem[];
    MultiPassStatus?: number;
    Questions?: IQuestionsItem[];
    Status: number;
    Timestamp?: string;
    AuthURL?: string;
    DeliveryType?: number;
    Language?: number;
    Passcode?: number;
}

interface IPoorProgrammingFix {
    name: string;
    value: boolean;
}
interface IDetailedDecision {
    AuthenticatedDataRequest?: null;
    Authentication: IAuthentication;
    CaseId: string;
    CaseNumber: string;
    Comment: string;
    ComputedData: IComputedData;
    Confidence: number;
    ExtendedDeviceInformation?: IFraudForceResult;
    Id: string;
    IdentityVerificationPayloadUrl?: string;
    RawData: IRawData;
    Result: number;
    Score: number;
    SessionId: string;
    Timestamp: string;
    Type: number;
    Version: number;
}
interface IAuthentication {
    DocumentAuthentication: IDocumentAuthentication;
    Id: string;
    KBA: IKBA;
    OTP: IOTP;
    Timestamp: string;
}
interface IDocumentAuthentication {
    FailureReasons: any[];
    OCRData: string | null;
    OCRDataStatus: number;
    Status: number;
    Url: string | null;
}
interface IKBA {
    AnswerUrl: string;
    MultiPassQuestions: IMultiPassQuestionsItem[];
    MultiPassStatus: number;
    Questions: IQuestionsItem[];
    Status: number;
    Timestamp: string;
}
interface IMultiPassQuestionsItem {
    Choices: IChoicesItem[];
    Id: number;
    QuestionText: string;
}
interface IChoicesItem {
    Answer: boolean;
    ChoiceText: string;
    Id: number;
}
export interface IQuestionsItem {
    Choices: IChoicesItem[];
    Id: number;
    QuestionText: string;
}
interface IOTP {
    AuthURL: string;
    DeliveryType: number;
    Language: number;
    Passcode: number;
    Status: number;
    Timestamp: string;
}
interface IComputedData {
    BlackList: IColorList;
    CaseType: number;
    Customer: ICustomer;
    Device: IDevice;
    ExtendedDevice: IExtendedDevice;
    GreyList: IColorList;
    Location: ILocation;
    Phone: IPhone;
    Transaction: ITransaction;
    Velocity: IVelocity;
    WhiteList: IColorList;
}
interface ICustomer {
    CaseType?: number;
    Email?: IEmail;
    HasBadHistory?: boolean;
    HasGoodHistory?: boolean;
    HasSuspiciousHistory?: boolean;
    IsIDMVMatchingSummaryRiskHigh?: null;
    IsIDMVMatchingSummaryRiskLow?: null;
    IsIDMVMatchingSummaryRiskMedium?: null;
    IsNameAddressCombinationValid?: null;
    IsReturningToPlatform?: boolean;
    Emails?: IEmailsItem[];
    FirstName?: string;
    LastName?: string;
    PhoneNumber: string | null;
    SocialSecurityNumber: string | null;
}
interface IEmail {
    ContainsDomainIssue: boolean;
    ContainsMailboxIssue: boolean;
    ContainsSyntaxIssue: boolean;
    IsAgeHigh: boolean;
    IsAgeLow: boolean;
    IsAgeMedium: boolean;
    IsDisposable: boolean;
    IsDomainNotAllowed: boolean;
    IsPopularityHigh: boolean;
    IsPopularityLow: boolean;
    IsPopularityMedium: boolean;
    IsUserNameNotAllowed: boolean;
    IsVelocityHigh: boolean;
    IsVelocityLow: boolean;
    IsVelocityMedium: boolean;
}
interface IDevice {
    IsFlashEnabled: boolean | null;
    IsJSEnabled: boolean;
    IsJavaEnabled: boolean;
}
interface IExtendedDevice {
    IsRegistrationRisky: boolean | null;
    PredictiveMlRisk: number | null;
    Risk: string | null;
}
interface ILocation {
    BIN?: null;
    CaseType?: number;
    IsIPCountryDomestic?: boolean;
    Addresses?: IAddresses;
    Coordinates?: ICoordinates;
}
interface IPhone {
    IsPhoneRisky: boolean;
}
interface ITransaction {
    Email?: IEmail;
    Emails?: IEmailsItem[];
}
interface IVelocity {
    CaseType: number;
    DecisionsWithin1Hour: number;
    DecisionsWithin24Hours: number;
    DecisionsWithin30Days: number;
    DecisionsWithin7Days: number;
    IsAccountNumberVelocityHigh: boolean | null;
    IsAddressLine1VelocityHigh: boolean | null;
    IsConsumerIdAccountNumberVelocityHigh: boolean | null;
    IsConsumerIdAddressLine1VelocityHigh: boolean | null;
    IsConsumerIdDeviceIdVelocityHigh: boolean | null;
    IsConsumerIdEmailVelocityHigh: boolean | null;
    IsConsumerIdIPVelocityHigh: boolean | null;
    IsConsumerIdPhoneNumberVelocityHigh: boolean | null;
    IsConsumerIdPostCodeVelocityHigh: boolean | null;
    IsConsumerIdSsnVelocityHigh: boolean | null;
    IsConsumerIdVelocityHigh: boolean | null;
    IsDeviceIdVelocityHigh: boolean | null;
    IsEmailVelocityHigh: boolean | null;
    IsIPVelocityHigh: boolean | null;
    IsPhoneNumberVelocityHigh: boolean | null;
    IsPostCodeVelocityHigh: boolean | null;
    IsSsnVelocityHigh: boolean | null;
}
interface IColorList {
    CaseType: number;
    WasAccountNumberHit: boolean;
    WasBinHit: boolean;
    WasCustomerIdHit: boolean;
    WasEmailDomainHit: boolean;
    WasFullEmailAddressHit: boolean;
    WasIPHit: boolean;
    WasPostCodeHit: boolean;
}
interface IRawData {
    BINInformation: null;
    Browser: string;
    CaseType: number;
    Customer: ICustomer;
    DeviceTag: string;
    IPAddresses: IIPAddressesItem[];
    Location: ILocation;
    NavigatorLanguage: string;
    NavigatorOscpu: string;
    NavigatorPlugins: string;
    OS: string | null;
    ScreenColorDepth: string;
    ScreenHeight: string;
    ScreenWidth: string;
    Transaction: ITransaction;
    TrustevCustomerId: string;
}
interface IEmailsItem {
    EmailAddress: string;
}
interface IIPAddressesItem {
    AnonymizerStatus: string;
    City: string;
    ClientIp: string;
    ConnectionType: string;
    Continent: string;
    Country: string;
    CountryCode: string;
    HostingFacility?: boolean;
    Id: string;
    LineSpeed: string;
    ProxyType: string;
    RoutingType: string;
    SLD: string;
    State: string;
    TLD: string;
}
interface IAddresses {
    Address1: string;
    Address2: string;
    Address3: string;
    City: string;
    CountryCode: string;
    FirstName: string;
    Id: string;
    IsDefault: boolean;
    LastName: string;
    PostalCode: string;
    State: string;
    Timestamp: Date;
    Type: number;
}
interface ICoordinates {
    DeviceBrowser: null;
    DeviceCellular: null;
    IP: string;
}


export class DetailedDecision implements IDetailedDecision {
    public Authentication: IAuthentication;
    public CaseId: string;
    public CaseNumber: string;
    public Comment: string;
    public ComputedData: IComputedData;
    public Confidence: number;
    public ExtendedDeviceInformation?: IFraudForceResult;
    public Id: string;
    public IdentityVerificationPayloadUrl?: string;
    public RawData: IRawData;
    public Result: number;
    public Score: number;
    public SessionId: string;
    public Timestamp: string;
    public Type: number;
    public Version: number;
    public IdentityVerificationDetail?: IdentityVerification;
    private ErrorMessages?: string;

    constructor(args: IDetailedDecision) {
        this.Authentication = args.Authentication;
        this.CaseId = args.CaseId;
        this.CaseNumber = args.CaseNumber;
        this.ComputedData = args.ComputedData;
        this.RawData = args.RawData;
        this.Comment = args.Comment;
        this.Confidence = args.Confidence;
        this.Id = args.Id;
        this.Result = args.Result;
        this.Score = args.Score;
        this.SessionId = args.SessionId;
        this.Timestamp = args.Timestamp;
        this.Type = args.Type;
        this.Version = args.Version;
        if (args.ExtendedDeviceInformation) {
            this.ExtendedDeviceInformation = args.ExtendedDeviceInformation;
        }
        if (args.IdentityVerificationPayloadUrl) {
            this.IdentityVerificationPayloadUrl = args.IdentityVerificationPayloadUrl;
        }
        // this.IdentityVerificationDetail = this.getIDVerify();
    }

    public formatAuthentication(color: string): GeneralAuthentication[] {
        const out = new Array<GeneralAuthentication>();
        if (this.Authentication.KBA !== undefined) {
            out.push({
                color: '',
                phone: this.RawData.Customer.PhoneNumber || '',
                title: trans('idvision.origination.standard.kba').toString(),
                description: trans('idvision.origination.standard.kba_desc').toString(),
                url: this.Authentication.KBA.AnswerUrl,
                MultiPassQuestions: this.Authentication.KBA.MultiPassQuestions,
                MultiPassStatus: this.Authentication.KBA.MultiPassStatus,
                Questions: this.Authentication.KBA.Questions,
                Status: this.Authentication.KBA.Status,
                Timestamp: this.Authentication.KBA.Timestamp,
            });
        }
        if (this.Authentication.OTP !== undefined) {
            out.push({
                color: '',
                phone: this.RawData.Customer.PhoneNumber || '',
                title: trans('idvision.origination.standard.otp').toString(),
                description: trans('idvision.origination.standard.otp_desc').toString(),
                url: this.Authentication.OTP.AuthURL,
                DeliveryType: this.Authentication.OTP.DeliveryType,
                Language: this.Authentication.OTP.Language,
                Passcode: this.Authentication.OTP.Passcode,
                Status: this.Authentication.OTP.Status,
                Timestamp: this.Authentication.OTP.Timestamp,
            });
        }
        return out;
    }

    public format(color: string): IResultDisplay {
        const out = ({
            color,
            title: '<strong>IDVision</strong><span class="font-weight-regular"> | Device Verification</span>',
            result: {
                color: this.resultColor(),
                text: this.toResult(),
                score: DefaultValue(this.Score, '0'),
                sections: new Array<Section>(),
            },
        } as IResultDisplay);
        out.result.sections.push({
            title: trans('idvision.origination.standard.deny_list').toString(),
            items: this.getLists(this.ComputedData.BlackList),
        });
        out.result.sections.push({
            title: trans('idvision.origination.standard.alert_list').toString(),
            items: this.getLists(this.ComputedData.GreyList),
        });
        out.result.sections.push({
            title: trans('idvision.origination.standard.allow_list').toString(),
            items: this.getLists(this.ComputedData.WhiteList),
        });
        const c = new Array<Item>();
        c.push({
            name: trans('idvision.origination.customer.badhistory').toString(),
            value: TransformBoolean(this.ComputedData.Customer.HasBadHistory),
        });
        c.push({
            name: trans('idvision.origination.customer.goodhistory').toString(),
            value: TransformBoolean(this.ComputedData.Customer.HasGoodHistory),
        });
        c.push({
            name: trans('idvision.origination.customer.suspect').toString(),
            value: TransformBoolean(this.ComputedData.Customer.HasSuspiciousHistory),
        });
        c.push({
            name: trans('idvision.origination.customer.returning').toString(),
            value: TransformBoolean(this.ComputedData.Customer.IsReturningToPlatform),
        });
        out.result.sections.push({
            title: trans('idvision.origination.customer.info').toString(),
            items: c,
        });
        out.result.sections.push({
            title: trans('iovation.fraudforce.emailvaild').toString(),
            items: this.getEmail(),
        });
        out.result.sections.push({
            title: trans('iovation.fraudforce.phonevaild').toString(),
            items: this.getPhone(),
        });
        out.result.sections.push({
            title: trans('idvision.origination.email.velocity').toString(),
            items: this.getVelocity(),
        });
        out.result.sections.push({
            title: trans('iovation.fraudforce.network').toString(),
            items: this.getNetwork(),
        });
        out.result.sections.push({
            title: trans('idvision.origination.standard.add_info').toString(),
            items: this.getInfo(),
        });
        return out;
    }

    private getInfo(): Item[] {
        const n = new Array<Item>();
        n.push({
            name: trans('iovation.fraudforce.language').toString(),
            value: this.RawData.NavigatorLanguage,
        });
        n.push({
            name: trans('iovation.fraudforce.screen').toString(),
            value: `${this.RawData.ScreenHeight}x${this.RawData.ScreenWidth} @ ${this.RawData.ScreenColorDepth}`,
        });
        n.push({
            name: trans('idvision.origination.standard.consumer_id').toString(),
            value: DefaultValue(this.RawData.TrustevCustomerId, 'No Customer Id'),
        });
        n.push({
            name: trans('idvision.origination.standard.national_id').toString(),
            value: DefaultValue(this.RawData.Customer.SocialSecurityNumber, 'No SSN sent'),
        });
        return n;
    }

    private getPhone(): Item[] {
        const n = new Array<Item>();
        n.push({
            name: trans('iovation.fraudforce.phone').toString(),
            value: DefaultValue(this.RawData.Customer.PhoneNumber, 'No Phone Number Sent'),
        });
        n.push({
            name: trans('idvision.origination.phone.risky').toString(),
            value: TransformBoolean(this.ComputedData.Phone.IsPhoneRisky),
        });
        return n;
    }

    private getNetwork(): Item[] {
        const i = new Array<Item>();
        this.RawData.IPAddresses.forEach((ip) => {
            i.push({
                name: trans('iovation.fraudforce.realip').toString(),
                value: ip.ClientIp,
            });
            i.push({
                name: trans('idvision.origination.standard.ip_conn').toString(),
                value: ip.ConnectionType,
            });
            i.push({
                name: trans('idvision.origination.standard.ip_speed').toString(),
                value: ip.LineSpeed,
            });
            i.push({
                name: trans('idvision.origination.standard.proxy').toString(),
                value: DefaultValue(ip.ProxyType, 'No'),
            });
            i.push({
                name: trans('idvision.origination.standard.anon').toString(),
                value: DefaultValue(ip.AnonymizerStatus, 'No'),
            });
            i.push({
                name: trans('idvision.origination.standard.locale').toString(),
                value: `${DefaultValue(ip.City, 'No City')}, ${DefaultValue(ip.State, 'No Region/State')}, ${DefaultValue(ip.Country, 'No Country')} (${DefaultValue(ip.CountryCode, '--')})`,
            });
            i.push({
                name: trans('idvision.origination.standard.host').toString(),
                value: TransformBoolean(ip.HostingFacility),
            });
            i.push({
                name: trans('idvision.origination.standard.routing').toString(),
                value: DefaultValue(ip.RoutingType, 'Unknown'),
            });
            i.push({
                name: trans('idvision.origination.standard.isp').toString(),
                value: `${DefaultValue(ip.SLD, 'UNKNOWN')}.${DefaultValue(ip.TLD, 'UNKNOWN')}`,
            });
        });
        return i;
    }

    private getEmail(): Item[] {
        const e = new Array<Item>();
        if (this.ComputedData.Customer.Email) {
            e.push({
                name: trans('idvision.origination.email.spam').toString(),
                value: TransformBoolean(this.ComputedData.Customer.Email.ContainsDomainIssue),
            });
            e.push({
                name: trans('idvision.origination.email.userspam').toString(),
                value: TransformBoolean(this.ComputedData.Customer.Email.ContainsMailboxIssue),
            });
            e.push({
                name: trans('idvision.origination.email.syntax').toString(),
                value: TransformBoolean(this.ComputedData.Customer.Email.ContainsSyntaxIssue),
            });
            e.push({
                name: trans('idvision.origination.email.dispose').toString(),
                value: TransformBoolean(this.ComputedData.Customer.Email.IsDisposable),
            });
            e.push({
                name: trans('idvision.origination.email.domain').toString(),
                value: TransformBoolean(this.ComputedData.Customer.Email.IsDomainNotAllowed),
            });
            e.push({
                name: trans('idvision.origination.email.mailbox').toString(),
                value: TransformBoolean(this.ComputedData.Customer.Email.IsUserNameNotAllowed),
            });
            e.push({
                name: trans('idvision.origination.email.popular').toString(),
                value: this.getFinal([
                    {
                        name: trans('standard.high').toString(),
                        value: this.ComputedData.Customer.Email.IsPopularityHigh,
                    },
                    {
                        name: trans('standard.med').toString(),
                        value: this.ComputedData.Customer.Email.IsPopularityMedium,
                    },
                    {
                        name: trans('standard.low').toString(),
                        value: this.ComputedData.Customer.Email.IsPopularityLow,
                    },
                ]),
            });
            e.push({
                name: trans('idvision.origination.email.age').toString(),
                value: this.getFinal([
                    {
                        name: trans('standard.high').toString(),
                        value: this.ComputedData.Customer.Email.IsAgeHigh,
                    },
                    {
                        name: trans('standard.med').toString(),
                        value: this.ComputedData.Customer.Email.IsAgeMedium,
                    },
                    {
                        name: trans('standard.low').toString(),
                        value: this.ComputedData.Customer.Email.IsAgeLow,
                    },
                ]),
            });
            e.push({
                name: trans('idvision.origination.email.velocity').toString(),
                value: this.getFinal([
                    {
                        name: trans('standard.high').toString(),
                        value: this.ComputedData.Customer.Email.IsVelocityHigh,
                    },
                    {
                        name: trans('standard.med').toString(),
                        value: this.ComputedData.Customer.Email.IsVelocityMedium,
                    },
                    {
                        name: trans('standard.low').toString(),
                        value: this.ComputedData.Customer.Email.IsVelocityLow,
                    },
                ]),
            });
        }
        return e;
    }
    private getName(s: string): string {
        if (s === 'high') {
            return trans('standard.high').toString();
        } else if (s === 'medium') {
            return trans('standard.med').toString();
        } else {
            return trans('standard.low').toString();
        }
    }
    private getFinal(bs: IPoorProgrammingFix[]): string {
        for (const b of bs) {
            if (b.value) {
                return this.getName(b.name);
            }
        }
        return 'nope';
    }

    private getVelocity(): Item[] {
        const a = new Array<Item>();
        a.push({
            name: trans('idvision.velocity.hour').toString(),
            value: DefaultValue(this.ComputedData.Velocity.DecisionsWithin1Hour, '0'),
        });
        a.push({
            name: trans('idvision.velocity.day').toString(),
            value: DefaultValue(this.ComputedData.Velocity.DecisionsWithin24Hours, '0'),
        });
        a.push({
            name: trans('idvision.velocity.week').toString(),
            value: DefaultValue(this.ComputedData.Velocity.DecisionsWithin7Days, '0'),
        });
        a.push({
            name: trans('idvision.velocity.month').toString(),
            value: DefaultValue(this.ComputedData.Velocity.DecisionsWithin30Days, '0'),
        });
        return a;
    }

    private getLists(c: IColorList): Item[] {
        const a = new Array<Item>();
        if (c) {
            a.push({
                name: trans('idvision.origination.customer.acctnum').toString(),
                value: TransformBoolean(c.WasAccountNumberHit),
            });
            a.push({
                name: trans('idvision.origination.customer.bin').toString(),
                value: TransformBoolean(c.WasBinHit),
            });
            a.push({
                name: trans('idvision.origination.customer.cust_id').toString(),
                value: TransformBoolean(c.WasCustomerIdHit),
            });
            a.push({
                name: trans('idvision.origination.case.domain_found').toString(),
                value: TransformBoolean(c.WasEmailDomainHit),
            });
            a.push({
                name: trans('idvision.origination.case.full_found').toString(),
                value: TransformBoolean(c.WasFullEmailAddressHit),
            });
            a.push({
                name: trans('idvision.origination.case.ip_found').toString(),
                value: TransformBoolean(c.WasIPHit),
            });
            a.push({
                name: trans('idvision.origination.case.zip_found').toString(),
                value: TransformBoolean(c.WasPostCodeHit),
            });
        }
        return a;
    }

    private resultColor(): string {
        if (this.Result) {
            const s = ResultHelper[this.Result];
            if (s === 'Pass') {
                return 'success';
            } else if (s === 'Flag' || s === 'Unknown') {
                return 'warning';
            } else {
                return 'error';
            }
        }
        return 'error';
    }

    private toResult(): string {
        return `${ResultHelper[this.Result]}`;
    }
}
